import background from 'src/assets/images/background.svg';
import backgroundDiamond from 'src/assets/images/background_diamond.png';
import backgroundDiamondFooter from 'src/assets/images/background_diamond_footer.png';
import backgroundDiamondSmall from 'src/assets/images/background_diamond_small.png';
import backgroundLogin from 'src/assets/images/background_login.webp';
import defaultAvatar from 'src/assets/images/default-avatar.svg';
import defaultUser from 'src/assets/images/default-user.png';
import documentView from 'src/assets/images/document-view.png';
import iconExcel from 'src/assets/images/icons/excel-icon.png';
import iconComputer from 'src/assets/images/icons/ic_computer.png';
import logoFull from 'src/assets/images/logos/logo-full.png';
import logo from 'src/assets/images/logos/logo.png';
import logoGrey from 'src/assets/images/logos/logo_grey.png';

export const IMAGES = {
  logo,
  logoFull,
  logoGrey,
  background,
  backgroundDiamond,
  backgroundDiamondSmall,
  backgroundDiamondFooter,
  backgroundLogin,
  defaultUser,
  defaultAvatar,
  iconComputer,
  documentView,
  iconExcel,
};
